module.exports = __webpack_public_path__ + "ab9e29b4b83b0b3643e9352439e6c658.svg";